import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import difference from 'lodash/difference';

var UsersFieldLabels = /* @__PURE__ */ ((UsersFieldLabels2) => {
  UsersFieldLabels2[UsersFieldLabels2["active"] = 0] = "active";
  UsersFieldLabels2[UsersFieldLabels2["webPortalAccess"] = 1] = "webPortalAccess";
  UsersFieldLabels2[UsersFieldLabels2["firstName"] = 2] = "firstName";
  UsersFieldLabels2[UsersFieldLabels2["lastName"] = 3] = "lastName";
  UsersFieldLabels2[UsersFieldLabels2["phoneNumber"] = 4] = "phoneNumber";
  UsersFieldLabels2[UsersFieldLabels2["posName"] = 5] = "posName";
  UsersFieldLabels2[UsersFieldLabels2["payrollId"] = 6] = "payrollId";
  UsersFieldLabels2[UsersFieldLabels2["email"] = 7] = "email";
  UsersFieldLabels2[UsersFieldLabels2["pin"] = 8] = "pin";
  UsersFieldLabels2[UsersFieldLabels2["locationIds"] = 9] = "locationIds";
  UsersFieldLabels2[UsersFieldLabels2["roleIds"] = 10] = "roleIds";
  return UsersFieldLabels2;
})(UsersFieldLabels || {});
var returnLabel = (field) => {
  if (field in UsersFieldLabels) {
    return i18n_config_default.t(
      `app.modals.userDetailsDiffModal.basic.${field}`
    );
  }
};
var diffUserDetailsFactory = (diffArray, state) => {
  if (diffArray.length > 0) {
    const user = generateUserDetailsObj(diffArray, state);
    return user;
  }
  return null;
};
var generateUserDetailsObj = (diffArray, state) => {
  const originalUserData = state.settings.changeData.originalData;
  const changedUserData = state.settings.changeData.data;
  const sortObject = {
    active: 0,
    webPortalAccess: 1,
    email: 2,
    firstName: 3,
    lastName: 4,
    phoneNumber: 5,
    posName: 6,
    payrollId: 7,
    pin: 8
  };
  const basicChanges = diffArray.filter(
    (diff) => diff.path[0] !== "locationIds" && diff.path[0] !== "roleIds" && diff.path[0] !== "locationsWithRoleIds"
  ).map((diff) => {
    var _a, _b, _c;
    if (!diff.path)
      return { field: null };
    const field = diff.path[((_a = diff.path) == null ? void 0 : _a.length) - 1];
    return {
      field,
      label: (_b = returnLabel(field)) != null ? _b : "",
      value: (_c = diff.rhs) != null ? _c : ""
    };
  }).sort((a, b) => sortObject[String(a.field)] - sortObject[String(b.field)]);
  const hasSomeLocationIds = diffArray.filter((diff) => diff.path[0] === "locationIds").length > 0 ? true : false;
  const hasSomeRoleIds = diffArray.filter((diff) => diff.path[0] === "roleIds").length > 0 ? true : false;
  const userLocationIds = originalUserData == null ? void 0 : originalUserData.locationIds;
  const locationIds = changedUserData == null ? void 0 : changedUserData.locationIds;
  const locationsWithRoleIds = changedUserData == null ? void 0 : changedUserData.locationsWithRoleIds;
  const associationsChanges = {
    locations: getLocationsWithRolesChanges(
      hasSomeLocationIds,
      userLocationIds,
      locationIds,
      locationsWithRoleIds,
      state
    ),
    roles: getRolesChanges(
      hasSomeRoleIds,
      originalUserData == null ? void 0 : originalUserData.roleIds,
      changedUserData == null ? void 0 : changedUserData.roleIds,
      state
    )
  };
  return { basic: basicChanges, associations: associationsChanges };
};
var getLocationsWithRolesChanges = (hasSomeLocationIds, userLocationIds, locationIds, locationsWithRoleIds, state) => {
  const locationsGroups = state.locations;
  const locationValues = [];
  if (hasSomeLocationIds) {
    const removedLocationIds = difference(
      userLocationIds,
      locationIds
    );
    const addedLocationIds = difference(
      locationIds,
      userLocationIds
    );
    const updatedLocationIds = Object.keys(locationsWithRoleIds).filter(
      (locationId) => !addedLocationIds.includes(Number(locationId))
    );
    if (removedLocationIds.length > 0) {
      removedLocationIds.map((removedLocationId) => {
        var _a;
        const locationData = Object.values(locationsGroups).filter(
          (locationGroup) => locationGroup.locations.find(
            (location) => location.id === Number(removedLocationId)
          )
        );
        if (locationData.length === 1) {
          const locationName = (_a = locationData[0].locations.find(
            (location) => location.id === Number(removedLocationId)
          )) == null ? void 0 : _a.streetLine1;
          locationValues.push({
            action: "remove",
            id: Number(removedLocationId),
            label: locationName != null ? locationName : "",
            roles: []
          });
        } else {
          locationValues.push({
            action: "",
            id: 0,
            label: "",
            roles: []
          });
        }
      });
    }
    if (addedLocationIds.length > 0) {
      addedLocationIds.map((addedLocationId) => {
        var _a;
        const locationData = Object.values(locationsGroups).filter(
          (locationGroup) => locationGroup.locations.find(
            (location) => location.id === Number(addedLocationId)
          )
        );
        if (locationData.length === 1) {
          const locationName = (_a = locationData[0].locations.find(
            (location) => location.id === Number(addedLocationId)
          )) == null ? void 0 : _a.streetLine1;
          locationValues.push({
            action: "add",
            id: Number(addedLocationId),
            label: locationName != null ? locationName : "",
            roles: locationsWithRoleIds[String(addedLocationId)] || []
          });
        } else {
          locationValues.push({
            action: "",
            id: 0,
            label: "",
            roles: []
          });
        }
      });
    }
    if (updatedLocationIds.length > 0) {
      updatedLocationIds.map((updatedLocationId) => {
        var _a;
        const locationData = Object.values(locationsGroups).filter(
          (locationGroup) => locationGroup.locations.find(
            (location) => location.id === Number(updatedLocationId)
          )
        );
        if (locationData.length === 1) {
          const locationName = (_a = locationData[0].locations.find(
            (location) => location.id === Number(updatedLocationId)
          )) == null ? void 0 : _a.streetLine1;
          locationValues.push({
            action: "update",
            id: Number(updatedLocationId),
            label: locationName != null ? locationName : "",
            roles: locationsWithRoleIds[String(updatedLocationId)] || []
          });
        } else {
          locationValues.push({
            action: "",
            id: 0,
            label: "",
            roles: []
          });
        }
      });
    }
  }
  return locationValues;
};
var getRolesChanges = (hasSomeRoleIds, userRoleIds, roleIds, state) => {
  const locationRoles = state.settings.selectedMode.currentSettings.roles;
  const roleValues = [];
  if (hasSomeRoleIds) {
    const removedLocationIds = difference(userRoleIds, roleIds);
    const addedLocationIds = difference(roleIds, userRoleIds);
    if (removedLocationIds.length > 0) {
      removedLocationIds.map((removedRoleId) => {
        var _a;
        if (locationRoles[removedRoleId]) {
          roleValues.push({
            action: "remove",
            id: Number(removedRoleId),
            label: (_a = locationRoles[removedRoleId].name) != null ? _a : ""
          });
        } else {
          roleValues.push({
            action: "",
            id: 0,
            label: ""
          });
        }
      });
    }
    if (addedLocationIds.length > 0) {
      addedLocationIds.map((addedRoleId) => {
        var _a;
        if (locationRoles[addedRoleId]) {
          roleValues.push({
            action: "add",
            id: Number(addedRoleId),
            label: (_a = locationRoles[addedRoleId].name) != null ? _a : ""
          });
        } else {
          roleValues.push({
            action: "",
            id: 0,
            label: ""
          });
        }
      });
    }
  }
  return roleValues;
};

export { diffUserDetailsFactory, getLocationsWithRolesChanges, getRolesChanges };
